<template>
  <div class="absolute text-black top-10 left-5 md:top-20 md:left-20" v-show="uid">
    <MenueButton @open="open_modal" />
  </div>

  <div class="w-full md:w-1/2 mx-auto px-5 mt-5">
    <div class="flex justify-center">
      <img :src="portrait" alt="Tobias Lorsbach" title="Tobias Lorsbach" class="block rounded-full w-16 h-16 md:w-24 md:h-24 m-3">
    </div>

    <div class="overflow-hidden bg-secondary-500 shadow rounded-md">
      <ul role="list" class="divide-y divide-secondary-800" v-if="linktree.length > 0">
        <draggable v-model="linktree2" @start="drag = true" @end="pushdata" item-key="id" handle=".handle" v-if="uid">
          <template #item="{ element }">
            <li>
              <AdminToolbar v-show="uid" :link="element" @delItem="delItem" @addItem="addItem" @editActive="editActive" />

              <LinkGroupAdmin :link="element" @edit="ids => { openSubEdit(ids) }" :uid="uid" v-show="uid" />
              <LinkGroup :link="element" @count="ids => { countSubClick(ids) }" :uid="uid" v-show="!uid" />

              <LinkSingleAdmin :link="element" @edit="id => { openEdit(id, element.clicks) }" :uid="uid" v-show="uid" />
              <LinkSingle :link="element" @count="id => { countClick(id, element.clicks) }" :uid="uid" v-show="!uid" />

              <ListBulletIcon class="h-6 w-6 handle cursor-move m-2" v-show="uid" />
            </li>
          </template>
        </draggable>

        <li v-for="(link, value) in activeLinks" :key="value" v-else>
          <LinkGroup :link="link" @count="ids => { countSubClick(ids) }" :uid="uid" />
          <LinkSingle :link="link" @count="id => { countClick(id, link.clicks) }" :uid="uid" />
          <ListBulletIcon class="h-6 w-6 handle cursor-move m-2" v-show="uid" />
        </li>

      </ul>
    </div>
    <div v-if="linktree.length == 0" class="p-3">
      <Loading v-if="!activeLinks" class="my-5" />
    </div>
  </div>

  <div class="flex justify-center ">
    <div class="m-4"><a href="https://tobeworks.de" target="_blank" class="text-gray-100 text-sm hover:text-gray-200 transition-all duration-200">{{ new Date().getFullYear() }}, Build by Tobeworks</a>
    </div>
  </div>

  <div class="flex justify-center" v-if="!uid">
    <div class="m-4"><router-link to="/login" class="text-gray-100 text-sm hover:text-gray-200 transition-all duration-200">Login</router-link>
    </div>
  </div>

  <div class="flex justify-center" v-else>
    <div class="m-4"><router-link to="/logout" class="text-gray-100 text-sm hover:text-gray-200 transition-all duration-200">Logout</router-link>
    </div>
  </div>

  <CommitForm :open="open" @close="getModalStatus" @getdata="getFormData" :art="open_art" :formdata="form" :mode="open_mode" />
  <!-- <CommitForm :open="open_sub" @close="getModalStatus" @getdata="getFormData" :formdata="form" art="group" :mode="open_mode"  /> -->
</template>

<script setup>
import { onMounted, reactive, ref, inject, computed, watch } from 'vue';
import draggable from 'vuedraggable'
import Loading from '@/core/components/Loading-Spinner.vue';
import { ListBulletIcon } from '@heroicons/vue/20/solid'
import { initializeApp } from "firebase/app";
import { getDatabase, ref as dbRef, set, push, remove, update, get } from "firebase/database";
import { useDatabaseList } from 'vuefire'
//import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { onAuthStateChanged, getAuth } from "firebase/auth";
import MenueButton from './Menue-Button.vue'
import LinkGroup from './Link-Group.vue';
import LinkGroupAdmin from './Link-Group-Admin.vue';
import LinkSingle from './Link-Single.vue';
import LinkSingleAdmin from './Link-Single-Admin.vue';
import AdminToolbar from './Admin-Toolbar.vue';
import CommitForm from './Commit-Form.vue';

const open = ref(false)
const open_mode = ref('new')
const open_art = ref('single')
//const open_sub = ref(false)
const set_mode = ref();
const current = ref(false)
const loading = ref(false);
const form = reactive({ title: 'Test Value', type: 'Link', link: 'https://google.com' })

const firebaseConfig = inject('firebaseConfig')
const firebase_dbpath = inject('firebase_dbpath')
const portrait = inject('portrait')
const db_path = ref(firebase_dbpath);
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const uid = ref(false)

const linktree = useDatabaseList(dbRef(db, db_path.value))
const linktree2 = useDatabaseList(dbRef(db, db_path.value))
const sortedItems = ref(linktree2);

const auth = getAuth(app);


watch(linktree, (val) => {
  const list = val.slice();
  const res = list.sort((a, b) => (a.sort > b.sort) ? 1 : 0)
  sortedItems.value = res
})

const activeLinks = computed(() => {

  const list = linktree.value.slice();

  if (uid.value === false) {
    return list
      .filter(link => link.active)
      .sort((a, b) => (a.sort > b.sort) ? 1 : 0)
  } else {
    return list.value
  }
}, false)

onAuthStateChanged(auth, (user) => {
  if (user) {
    uid.value = user.uid;
  } else {
    uid.value = false;
  }
});


const pushdata = () => {

  let i = 0;
  const transformedObject = sortedItems.value.reduce((obj, item) => {
    const { id, ...rest } = item;

    obj[id] = rest;
    obj[id].date = Date.now()
    obj[id].sort = i++
    return obj;
  }, {});

  set(dbRef(db, db_path.value),
    transformedObject
  )

  return true
}

onMounted(async () => {
  loading.value = true;
});

function addItem(set_id) {
  current.value = set_id;
  open.value = true;
  open_art.value = 'group_sub';
}

function delItem(item) {
  const itempath = db_path.value + '/' + item;
  const ref = dbRef(db, itempath);
  remove(ref);
}


function pushEntry() {

  const pushid = dbRef(db, db_path.value);

  const newPostRef = push(pushid);
  const workload = {
    "date": Date.now(),
    "title": form.title,
    "link": form.link,
    "type": form.type,
    "mode": set_mode.value,
    "clicks": 0,
    "active": true
  }

  set(newPostRef, workload);
  open.value = false;
}

function editEntry() {
  console.log('editEntry', form)

  // const [activeStatus, id] = res;

  const subpath = `${db_path.value}/${form.id}`
  const editid = dbRef(db, subpath);
  form.id = null
  update(editid, form);
}


function editSubEntry() {


  const subpath = `${db_path.value}/${form.parent_id}/sub/${form.id}`
  const editid = dbRef(db, subpath);
  form.id = null
  form.parent_id = null;
  update(editid, form);
}

const getFormData = res => {
  console.log('getFormData', res)
  form.title = res.data.title;
  form.type = res.data.type;
  form.link = res.data.link;
  open.value = false;

  switch (res.art) {
    case 'single':
      if (res.mode == 'edit') {
        editEntry();
      } else {
        pushEntry()
      }
      break;
    case 'group':
      if (res.mode == 'edit') {
        editEntry();
      } else {
        pushEntry()
      }
      break;
    case 'group_sub':
      if (res.mode == 'edit') {
        editSubEntry();
      } else {
        pushSubEntry()
      }
      break;
  }

}

function pushSubEntry() {
  const subpath = `${db_path.value}/${current.value}/sub`
  const pushid = dbRef(db, subpath);


  const newPostRef = push(pushid);
  const workload = {
    "date": Date.now(),
    "link": form.link,
    "title": form.title,
    "type": form.type,
    "clicks": 0,
    "active": true
  }

  set(newPostRef, workload);
  open.value = false;
}

function editActive(res) {

  const [activeStatus, id] = res;

  const subpath = `${db_path.value}/${id}`
  const editid = dbRef(db, subpath);
  const workload = {
    "active": activeStatus
  }
  update(editid, workload);
}

const countClick = (id, clicks) => {
  IncrementView(clicks, id)
}

const openEdit = async (id) => {

  const snapshot = await get(dbRef(db, `${db_path.value}/${id}`))

  if (snapshot.exists()) {
    const data = snapshot.val()
    form.title = data.title;
    form.type = data.type;
    form.link = data.link;
    form.id = id;

    open_modal('single', 'edit')
  } else {
    console.error("No data available");
  }

}

const openSubEdit = async (ids) => {

  const [id, parent_id] = ids;
  const snapshot = await get(dbRef(db, `${db_path.value}/${parent_id}/sub/${id}`))

  if (snapshot.exists()) {
    const data = snapshot.val()

    form.title = data.title;
    form.type = data.type;
    form.link = data.link;
    form.id = id;
    form.parent_id = parent_id;
    open_art.value = 'group_sub';
    open_modal('group_sub', 'edit')
  } else {
    console.error("No data available");
  }

}


const countSubClick = async (ids) => {

  const [id, parent_id, clicks] = ids;
  const increment = clicks + 1
  const subpath = `${db_path.value}/${parent_id}/sub/${id}`
  const editid = dbRef(db, subpath);

  const workload = {
    "clicks": increment
  }
  update(editid, workload);

}

function IncrementView(clicks, id) {

  const increment = clicks + 1
  const subpath = `${db_path.value}/${id}`
  const editid = dbRef(db, subpath);
  const workload = {
    "clicks": increment
  }
  update(editid, workload);
}

const open_modal = (res, mode = 'new') => {
  open_mode.value = mode
  set_mode.value = res
  open_art.value = res
  open.value = true
}

const getModalStatus = (res) => {
  open.value = res;
}
</script>